/*
 * SS Video Lightbox — opens YouTube / Vimeo tiles in a large modal player
 * instead of playing inside the small tile. 2026-09-24 (client: Olivia).
 * Loaded by snippets/ss-video-lightbox.liquid.
 *
 * Trigger contract (any element, usually the tile wrapper):
 *   data-ss-video="<video id>"
 *   data-ss-video-provider="youtube|vimeo"      (default youtube)
 *   data-ss-video-shape="landscape|portrait"    (portrait = 9:16 Shorts)
 *   data-ss-video-title="…"                     (optional, for a11y + caption)
 *   data-ss-video-poster="<url>"                (optional; YouTube auto-derived)
 *   data-ss-video-list="<YouTube playlist id>"  (optional, 2026-10-01; plays the
 *                                                playlist; use data-ss-video="videoseries")
 *                                                (2026-10-01c: with a real video id + list, starts that
 *                                                video inside the playlist)
 *   data-ss-video-provider="instagram"          (2026-10-01b; data-ss-video = reel/post
 *   data-ss-video-ig-type="reel|p|tv"            shortcode; loads instagram.com/<type>/<code>/embed
 *                                                straight away, no poster/play step)
 *
 * Flow: tile click -> modal shows the poster + big play button -> play loads
 * youtube-nocookie.com/embed/ID?autoplay=1&rel=0 in the large frame (the
 * native YouTube logo/title in that player link out to YouTube) + a
 * "Watch on YouTube" link under the player. Close via button, Esc, or a
 * click on the backdrop; closing removes the iframe (stops playback).
 * Focus is trapped in the dialog and returned to the tile; page scroll is
 * locked while open. Idempotent.
 */
(function () {
  if (window.__ssVideoLightboxInit) return;
  window.__ssVideoLightboxInit = true;

  var modal, dialog, frame, poster, playBtn, link, caption, lastFocus, current;

  function el(tag, cls, attrs) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (attrs) for (var k in attrs) n.setAttribute(k, attrs[k]);
    return n;
  }

  function build() {
    if (modal) return;
    modal = el('div', 'ssvl', { role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Video player', hidden: '' });
    var backdrop = el('div', 'ssvl__backdrop', { 'data-ssvl-close': '' });
    dialog = el('div', 'ssvl__dialog');
    var close = el('button', 'ssvl__close', { type: 'button', 'aria-label': 'Close video', 'data-ssvl-close': '' });
    close.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
    frame = el('div', 'ssvl__frame');
    poster = el('img', 'ssvl__poster', { alt: '', decoding: 'async' });
    playBtn = el('button', 'ssvl__play', { type: 'button', 'aria-label': 'Play video' });
    playBtn.innerHTML = '<svg viewBox="0 0 68 48" width="96" height="68" aria-hidden="true" focusable="false"><path d="M66.52 7.74a8 8 0 0 0-5.65-5.67C55.79 1 34 1 34 1S12.21 1 7.13 2.07A8 8 0 0 0 1.48 7.74 83.1 83.1 0 0 0 .4 24a83.1 83.1 0 0 0 1.08 16.26 8 8 0 0 0 5.65 5.67C12.21 47 34 47 34 47s21.79 0 26.87-1.07a8 8 0 0 0 5.65-5.67A83.1 83.1 0 0 0 67.6 24a83.1 83.1 0 0 0-1.08-16.26z" fill="#be1f2d"/><path d="M27 34V14l17 10z" fill="#fff"/></svg>';
    frame.appendChild(poster);
    frame.appendChild(playBtn);
    var meta = el('div', 'ssvl__meta');
    caption = el('p', 'ssvl__title');
    link = el('a', 'ssvl__ext', { target: '_blank', rel: 'noopener' });
    meta.appendChild(caption);
    meta.appendChild(link);
    dialog.appendChild(close);
    dialog.appendChild(frame);
    dialog.appendChild(meta);
    modal.appendChild(backdrop);
    modal.appendChild(dialog);
    document.body.appendChild(modal);

    playBtn.addEventListener('click', play);
    poster.addEventListener('click', play);
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-ssvl-close]')) close_();
    });
    modal.addEventListener('keydown', onKey);
  }

  function watchUrl(v) {
    if (v.list && v.id && v.id !== 'videoseries') return 'https://www.youtube.com/watch?v=' + encodeURIComponent(v.id) + '&list=' + encodeURIComponent(v.list);
    if (v.list) return 'https://www.youtube.com/playlist?list=' + encodeURIComponent(v.list);
    if (v.provider === 'instagram') return 'https://www.instagram.com/' + v.igType + '/' + encodeURIComponent(v.id) + '/';
    return v.provider === 'vimeo' ? 'https://vimeo.com/' + v.id : 'https://www.youtube.com/watch?v=' + v.id;
  }
  function embedUrl(v) {
    if (v.list && v.id && v.id !== 'videoseries') return 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(v.id) + '?list=' + encodeURIComponent(v.list) + '&autoplay=1&rel=0&playsinline=1';
    if (v.list) return 'https://www.youtube-nocookie.com/embed/videoseries?list=' + encodeURIComponent(v.list) + '&autoplay=1&rel=0&playsinline=1';
    if (v.provider === 'instagram') return 'https://www.instagram.com/' + v.igType + '/' + encodeURIComponent(v.id) + '/embed/';
    return v.provider === 'vimeo'
      ? 'https://player.vimeo.com/video/' + v.id + '?autoplay=1'
      : 'https://www.youtube-nocookie.com/embed/' + v.id + '?autoplay=1&rel=0&playsinline=1';
  }

  function open(trigger) {
    build();
    var id = (trigger.getAttribute('data-ss-video') || '').trim();
    if (!id) return;
    current = {
      id: id,
      provider: (trigger.getAttribute('data-ss-video-provider') || 'youtube').toLowerCase(),
      shape: trigger.getAttribute('data-ss-video-shape') === 'portrait' ? 'portrait' : 'landscape',
      title: trigger.getAttribute('data-ss-video-title') || '',
      poster: trigger.getAttribute('data-ss-video-poster') || '',
      list: (trigger.getAttribute('data-ss-video-list') || '').trim(),
      igType: (trigger.getAttribute('data-ss-video-ig-type') || 'reel').toLowerCase()
    };
    if (!/^(reel|p|tv)$/.test(current.igType)) current.igType = 'reel';
    if (current.list) current.provider = 'youtube';
    if (!current.poster && current.provider === 'youtube' && id !== 'videoseries') current.poster = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
    lastFocus = document.activeElement;

    clearFrame();
    dialog.className = 'ssvl__dialog ssvl__dialog--' + current.shape;
    poster.hidden = !current.poster;
    if (current.poster) { poster.src = current.poster; poster.alt = current.title; }
    playBtn.hidden = false;
    playBtn.setAttribute('aria-label', 'Play video' + (current.title ? ': ' + current.title : ''));
    caption.textContent = current.title;
    caption.hidden = !current.title;
    link.href = watchUrl(current);
    link.textContent = (current.provider === 'vimeo' ? 'Watch on Vimeo' : current.provider === 'instagram' ? 'View on Instagram' : 'Watch on YouTube') + ' ↗';
    modal.setAttribute('aria-label', current.title ? 'Video: ' + current.title : 'Video player');

    modal.hidden = false;
    document.documentElement.classList.add('ssvl-locked');
    void modal.offsetWidth; // start the fade from opacity 0
    modal.classList.add('is-open');
    playBtn.focus({ preventScroll: true });
    if (current.provider === 'instagram') play(); // IG embed has its own play control
  }

  function play() {
    if (!current) return;
    clearFrame();
    var f = el('iframe', 'ssvl__iframe', {
      src: embedUrl(current),
      title: current.title || 'Video',
      allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
      allowfullscreen: '',
      referrerpolicy: 'strict-origin-when-cross-origin'
    });
    if (current.provider === 'instagram') { f.setAttribute('scrolling', 'no'); f.style.background = '#fff'; }
    poster.hidden = true;
    playBtn.hidden = true;
    frame.appendChild(f);
    f.focus({ preventScroll: true });
  }

  function clearFrame() {
    if (!frame) return;
    Array.prototype.slice.call(frame.querySelectorAll('iframe')).forEach(function (f) { f.remove(); });
  }

  function close_() {
    if (!modal || modal.hidden) return;
    clearFrame();
    modal.classList.remove('is-open');
    modal.hidden = true;
    document.documentElement.classList.remove('ssvl-locked');
    current = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function focusables() {
    return Array.prototype.filter.call(
      dialog.querySelectorAll('button, a[href], iframe, [tabindex]:not([tabindex="-1"])'),
      function (n) { return !n.hidden && n.offsetParent !== null; }
    );
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close_(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  // Esc also works when focus is inside the YouTube iframe's parent document
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hidden) close_();
  });

  // Capture phase: runs before any legacy inline "play in tile" handler.
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-ss-video]');
    if (!t || (modal && modal.contains(t))) return;
    e.preventDefault();
    e.stopPropagation();
    open(t);
  }, true);
  // Keyboard activation for non-button tiles
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-ss-video]') || t.tagName === 'BUTTON' || t.tagName === 'A') return;
    e.preventDefault();
    open(t);
  });

  window.SSVideoLightbox = { open: open, close: close_ };
})();
